import {
    CampaignDetailsAndProducts,
    CampaignDetailsAndProductsCacheWrapper,
} from "../types/CampaignAdminTypes"

/**
 * Wraps the data for caching.
 * This ensures that even `null` responses (which are valid and should be cached)
 * are distinguishable from a cache miss (`null` entry in the cacher).
 *
 * @param data - The actual data to cache (may be `null`).
 * @returns A wrapper object to store in the cache.
 */
export const WrapForCache = (
    data: CampaignDetailsAndProducts | null,
): CampaignDetailsAndProductsCacheWrapper => {
    return { result: data }
}

/**
 * Unwraps the cached wrapper to retrieve the original data.
 *
 * @param cached - The wrapper object retrieved from the cache.
 * @returns The cached data, which may be `null`.
 */
export const UnwrapFromCache = (
    cached: CampaignDetailsAndProductsCacheWrapper,
): CampaignDetailsAndProducts | null => {
    return cached.result
}
